import QRCode from "qrcode";
const xml = (text: string) =>
  text.replace(
    /[&<>"']/g,
    (c) =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&apos;",
      })[c]!,
  );
function lines(text: string, limit: number) {
  const result: string[] = [];
  let line = "";
  for (const word of text.split(/\s+/)) {
    if ((line + " " + word).trim().length > limit && line) {
      result.push(line);
      line = "";
    }
    if (word.length > limit) {
      if (line) {
        result.push(line);
        line = "";
      }
      for (let start = 0; start < word.length; start += limit)
        result.push(word.slice(start, start + limit));
    } else line = (line + " " + word).trim();
  }
  if (line) result.push(line);
  return result;
}
export async function createQRSign(title: string, url: string) {
  const qr = await QRCode.toDataURL(url, {
    width: 960,
    margin: 4,
    errorCorrectionLevel: "M",
    color: { dark: "#183d34", light: "#ffffff" },
  });
  const headings = lines(title, 36)
    .slice(0, 4)
    .map(
      (line, i) =>
        `<text x="420" y="${112 + i * 46}" font-size="35" font-weight="700">${xml(line)}</text>`,
    )
    .join("");
  const address = lines(url, 66)
    .slice(0, 4)
    .map(
      (line, i) =>
        `<text x="420" y="${1006 + i * 23}" font-size="16">${xml(line)}</text>`,
    )
    .join("");
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="840" height="1188" viewBox="0 0 840 1188"><rect width="840" height="1188" fill="white"/><g font-family="Arial,Helvetica,sans-serif" fill="#183d34" text-anchor="middle"><text x="420" y="48" font-size="20" font-weight="700">WayTogether Maps</text>${headings}<text x="420" y="315" font-size="25" font-weight="700">OPEN THE CURRENT MAP</text><text x="420" y="350" font-size="23">ABRIR EL MAPA ACTUAL</text><text x="420" y="384" font-size="23">OUVRIR LA CARTE À JOUR</text><image x="140" y="407" width="560" height="560" href="${qr}"/>${address}<text x="420" y="1122" font-size="17">Review while stopped · Consulte cuando esté detenido</text><text x="420" y="1148" font-size="17">Consultez la carte à l’arrêt</text></g></svg>`;
  return svg;
}

export async function downloadQRSign(title: string, url: string) {
  const svg = await createQRSign(title, url);
  const blobURL = URL.createObjectURL(
    new Blob([svg], { type: "image/svg+xml" }),
  );
  const link = document.createElement("a");
  link.href = blobURL;
  link.download = "waytogether-current-map-sign.svg";
  link.click();
  setTimeout(() => URL.revokeObjectURL(blobURL), 60000);
}
